import dropdownMultiSelectGenerator from './DropdownMultiSelectGenerator';

export default dropdownMultiSelectGenerator('medium');
